module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"header":"Podaj dane swojej strony lub profilu social media","description":"Super! Afiliacja to świetny wybór. Teraz daj nam znać, gdzie będziesz korzystać z naszych narzędzi – dodaj swój profil w mediach społecznościowych lub stronę internetową (blog, serwis)."}}')
  delete Component.options._Ctor
}
